import { render, staticRenderFns } from "./classRecordList.vue?vue&type=template&id=f4aca026&scoped=true&"
import script from "./classRecordList.vue?vue&type=script&lang=js&"
export * from "./classRecordList.vue?vue&type=script&lang=js&"
import style0 from "./classRecordList.vue?vue&type=style&index=0&id=f4aca026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aca026",
  null
  
)

export default component.exports